import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";


type GlobalAppSettingKey = "max_total_storage" | "is_under_maintenance" | "admin_message" | "display_admin_message" | "users_can_login" | "users_can_register" | "users_can_upload" | "users_can_create_characters";
interface GlobalAppSetting {
    key: string;
    value: string;
    id: string;
}

type MappedGlobalAppSetting = Record<GlobalAppSettingKey, string>

export const useGlobalSettings = (): MappedGlobalAppSetting | null => {
    const [data, setData] = useState<MappedGlobalAppSetting | null>(null)
    const queries = useQueryClient();
    const isFetchingSettings = useIsFetching({ queryKey: ['globalAppSettings'] })
    const queryData = queries.getQueryData(["globalAppSettings"]) as GlobalAppSetting[]
    useEffect(() => {
        if (queryData == null) return
        const parsedQueryData = settingsToMap(queryData)
        setData(parsedQueryData);
    }, [isFetchingSettings])
    return data
}


function settingsToMap(settings: GlobalAppSetting[]): MappedGlobalAppSetting {
    return settings.reduce((acc, setting) => ({ ...acc, [setting.key as GlobalAppSettingKey]: setting.value }), {} as MappedGlobalAppSetting)
}
